import { Phone, MessageCircle, FileText } from "lucide-react";
import { contactInfo } from "../mocks/homeData";

export default function FloatingActions() {
  return (
    <div className="fixed right-4 md:right-6 bottom-16 md:bottom-8 z-40 flex flex-col gap-3">
      <a
        href={`tel:${contactInfo.phone.replace(/\s/g, "")}`}
        className="w-12 h-12 md:w-14 md:h-14 bg-white rounded-full shadow-lg border border-gray-100 flex items-center justify-center hover:bg-copper transition-all duration-300 group"
        title="Bizi Arayin"
      >
        <Phone className="w-5 h-5 md:w-6 md:h-6 text-navy group-hover:text-white transition-colors" />
      </a>
      <a
        href={`https://wa.me/${contactInfo.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 md:w-14 md:h-14 bg-white rounded-full shadow-lg border border-gray-100 flex items-center justify-center hover:bg-green-600 transition-all duration-300 group"
        title="WhatsApp"
      >
        <MessageCircle className="w-5 h-5 md:w-6 md:h-6 text-navy group-hover:text-white transition-colors" />
      </a>
      <a
        href="#contact"
        onClick={(e) => {
          e.preventDefault();
          document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
        className="w-12 h-12 md:w-14 md:h-14 bg-copper rounded-full shadow-lg flex items-center justify-center hover:bg-copper-dark transition-all duration-300"
        title="Teklif Al"
      >
        <FileText className="w-5 h-5 md:w-6 md:h-6 text-white" />
      </a>
    </div>
  );
}
